<template>
  <div class="matchListPage">
    <Form>
      <Row :gutter="24">
        <Col :span="9">
          <FormItem label="报到时间" :label-col="labelCol" :wrapper-col="wrapperCol">
            <DatePicker :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="searchDate"/>
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem>
            <Input placeholder="请输入患者姓名/电话/身份证" v-model="searchInfo"></Input>
          </FormItem>
        </Col>
        <Col :span="3">
          <FormItem>
            <Button type="primary" @click="handleSearch('search')">搜索</Button>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div>
      <Table size="small" :columns="columns" :dataSource="tableData" border rowKey="id" :pagination="false" :customRow="customRow" :rowClassName="rowClassName">
        <template slot="gender" slot-scope="text, record" >
          <span>{{record.gender === 1 ? '男' : '女'}}</span>
        </template>
      </Table>
    </div>
    <div class="pageWrapper">
      <Pagination v-model="currentPage" :total="totalPage" @change="changePage"></Pagination>
    </div>
    <div class="footer">
      <div>
        <Button size="large" @click="closeOnlinePatientModal">取消</Button>
        <Button type="primary" size="large" @click="handleMatch">匹配</Button>
      </div>
    </div>
    <Modal v-model="showMatchModal"  v-if="showMatchModal" title="匹配" :footer="null" :width="900">
      <onlineMatch @closeMatchModal="closeMatchModal" @handleSureMatch="handleSureMatch" :patientId="patientId" modalType="first"></onlineMatch>
    </Modal>
  </div>
</template>

<script>
import { Form, Input, Button, Row, Col, Table, Pagination, DatePicker, Modal } from 'ant-design-vue' 
import moment from 'moment'
import { switchTimeFormat, toast } from '../../libs/utils'
import onlineMatch from './onlineMatch'
import { getOnlineCheckinList } from '../../api/onlineCheckin'
export default {
  props: {
    currentCenterId: {
      type: Number,
      default: 0
    }
  },
  components: {
    Form,
    FormItem: Form.Item,
    Input,
    Button,
    Row,
    Col,
    Table,
    Pagination,
    DatePicker,
    Modal,
    onlineMatch
  },
  data () {
    return {
      labelCol: {
        md: {span: 3}, lg: { span: 2 }, xl: { span: 8 }, xxl: { span: 6 }, xs: {span: 4}
      },
      wrapperCol: {
        md: {span: 21}, lg: { span: 22 }, xl: { span: 16 }, xxl: { span: 18 }, xs: {span: 20}
      },
      searchDate: moment(switchTimeFormat(new Date().valueOf(), 1)),
      searchInfo: '',
      columns: [
        { title: '最近报到时间', dataIndex: 'checkin_time' },
        { title: '姓名', dataIndex: 'real_name' },
        { title: '电话', dataIndex: 'mobile' },
        { title: '身份证号', dataIndex: 'id_number' },
        { title: '性别', dataIndex: 'gender', scopedSlots: { customRender: 'gender' } }
      ],
      tableData: [],
      currentPage: 1,
      pageNo: 1,
      pageSize: 10,
      totalPage: 0,
      patientId: '',
      patientInfo: {},
      showMatchModal: false
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
     // 选中某一条标蓝
    customRow (record) {
      return {
        on: {
          click: () => {
            this.patientId = record.id
            this.patientInfo = record
          }
        }
      }
    },
    rowClassName (record) {
      return record.id === this.patientId ? 'clickRowStyle' : '';
    },
    async handleSearch (type) {
      if (type === 'search') {
        this.pageNo = 1
        this.currentPage = 1
      }
      let params = {
        pageNumber: this.pageNo,
        pageSize: this.pageSize,
        imageCenterId: this.currentCenterId
      }
      if (this.searchDate) params.checkInTime = switchTimeFormat(this.searchDate, 1)
      if (this.searchInfo) params.search = this.searchInfo
      let data = await getOnlineCheckinList(params)
      if (data) {
        this.tableData = data.results
        this.totalPage = data.totalCount
      }
    },
    handleMatch () {
      if (!this.patientId) return toast({ title: '提示', type: 'warning', msg: '请选择线上报到患者' })
      this.showMatchModal = true
    },
    handleSureMatch (val) {
      this.showMatchModal = false
      this.$emit('handleSureMatch', val)
    },
    closeMatchModal () {
      this.showMatchModal = false
    },
    // 分页
    async changePage (page) {
      this.pageNo = page
      this.handleSearch()
    },
    // 取消
    closeOnlinePatientModal () {
      this.$emit('closeOnlinePatientModal')
    }
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.matchListPage{
  .clickRowStyle{
    background: @primaryColor;
  }
  .ant-table-tbody>.clickRowStyle:hover>td {
    background: @primaryColor;
  }
  .pageWrapper{
    margin-top:20px;
  }
  .footer{
    .modalFooter();
  }
}
</style>